/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SetDefs from './defs.defs.js'

const $nsid = 'tools.ozone.set.querySets'

export { $nsid }

/** Query available sets */
const main = l.query(
  $nsid,
  l.params({
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
    namePrefix: l.optional(l.string()),
    sortBy: l.optional(
      l.withDefault(l.enum(['name', 'createdAt', 'updatedAt']), 'name'),
    ),
    sortDirection: l.optional(l.withDefault(l.enum(['asc', 'desc']), 'asc')),
  }),
  l.jsonPayload({
    sets: l.array(l.ref<SetDefs.SetView>((() => SetDefs.setView) as any)),
    cursor: l.optional(l.string()),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
